

import Header from "../components/Header";
import {mapMutations} from "vuex";
import Footer from "../components/Footer";
export default {
    components: {Footer, Header},
    data() {
        return {
            intervalFrontendVersion: null,
            intervalBasketCount: null,
        }
    },
    created() {
        this.getBasketCount();
    },
    mounted() {
        this.intervalFrontendVersion = setInterval(this.checkFrontendVersion, 30000);
        this.intervalBasketCount = setInterval(this.getBasketCount, 20000);
        window.addEventListener('focus', this.checkFrontendVersion);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    },
    destroyed() {
        clearInterval(this.intervalFrontendVersion);
        clearInterval(this.intervalBasketCount);
        window.removeEventListener('focus', this.checkFrontendVersion);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },
    watch:{
        $route () {
            this.checkFrontendVersion();
            this.closeAllMenu();
        }
    },
    computed: {
        isHomepage(){
            return this.$route.name === 'index';
        },
        needRedirect () {
            return this.$store.state.version.needRedirect
        },
    },
    methods: {
        ...mapMutations({
            closeAllMenu: 'closeAllMenu',
            setBasketCount: 'setBasketCount',
        }),
        async checkFrontendVersion(){
            if(!this.$store.state.version.needRedirect){
                try {
                    const {data: response} = await this.$axios.get('api/v1/version');
                    this.$store.commit('checkVersion', response.version)
                } catch (e) {

                }
            }
        },
        handleVisibilityChange() {
            if(document.visibilityState === 'visible'){
                this.checkFrontendVersion();
            }
        },
        reloadPage() {
            window.location.reload();
        },
        async getBasketCount(){
            try{
                const {data: response} = await this.$axios.get('api/v1/basket/count');
                this.setBasketCount(response.count);
            } catch (e) {

            }
        },
    },
}
